import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
interface SlideInsightProps {
  onContinue: () => void;
}
export function SlideInsight({
  onContinue
}: SlideInsightProps) {
  const [revealedCount, setRevealedCount] = useState(0);
  const bullets = ['Segmentation becomes broad', 'Messaging becomes generic', 'Content becomes static', 'No behavioral insights are captured'];
  // Auto-reveal bullets one at a time
  useEffect(() => {
    if (revealedCount < bullets.length) {
      const timer = setTimeout(() => {
        setRevealedCount(prev => prev + 1);
      }, 1200);
      return () => clearTimeout(timer);
    }
  }, [revealedCount, bullets.length]);
  const allRevealed = revealedCount >= bullets.length;
  return <div className="h-full w-full flex flex-col px-12 py-16 md:px-24 md:py-20 max-w-7xl mx-auto relative" data-id="element-278">
      {/* Background abstract diagram */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none z-0 flex items-center justify-end opacity-20" data-id="element-279">
        <motion.div initial={{
        opacity: 0,
        scale: 0.8
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 2,
        ease: 'easeOut'
      }} className="w-[800px] h-[800px] rounded-full border-[1px] border-teal-400/30 relative" data-id="element-280">
          <div className="absolute inset-20 rounded-full border-[1px] border-teal-400/20" data-id="element-281" />
          <div className="absolute inset-40 rounded-full border-[1px] border-teal-400/10" data-id="element-282" />
          <div className="absolute top-1/2 left-0 w-full h-[1px] bg-teal-400/20" data-id="element-283" />
          <div className="absolute left-1/2 top-0 w-[1px] h-full bg-teal-400/20" data-id="element-284" />
        </motion.div>
      </div>

      <div className="flex-1 flex flex-col justify-center z-10 relative" data-id="element-285">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} className="text-5xl md:text-6xl lg:text-7xl font-serif leading-tight text-white mb-6" data-id="element-286">
          What gets lost with
          <br data-id="element-287" />
          <span className="text-white/60" data-id="element-288">minimal attention?</span>
        </motion.h2>

        <motion.p initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.3
      }} className="text-2xl text-teal-400 font-medium mb-12" data-id="element-289">
          Without continuous focus:
        </motion.p>

        <div className="space-y-6 max-w-2xl" data-id="element-290">
          {bullets.map((bullet, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          x: -20,
          filter: 'blur(10px)'
        }} animate={{
          opacity: idx < revealedCount ? 1 : 0.15,
          x: idx < revealedCount ? 0 : -10,
          filter: idx < revealedCount ? 'blur(0px)' : 'blur(2px)'
        }} transition={{
          duration: 0.6,
          ease: 'easeOut'
        }} className="flex items-center gap-4 text-xl md:text-2xl text-white" data-id="element-291">
              <motion.div animate={{
            backgroundColor: idx < revealedCount ? '#00D4AA' : '#1E2D4A',
            scale: idx < revealedCount ? [1, 1.5, 1] : 1
          }} transition={{
            duration: 0.3
          }} className="w-2.5 h-2.5 rounded-full flex-shrink-0" data-id="element-292" />
              {bullet}
            </motion.div>)}
        </div>

        <div className="mt-16 h-16" data-id="element-293">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: allRevealed ? 1 : 0,
          y: allRevealed ? 0 : 20
        }} transition={{
          duration: 0.5,
          delay: 0.5
        }} data-id="element-294">
            <Button onClick={onContinue} data-id="element-295">See the impact</Button>
          </motion.div>
        </div>
      </div>
    </div>;
}